const contactRequestEndpoints = {
  CREATE_CONTACT_REQUEST: 'contact-request/contact-requests',
  LIST_CONTACT_REQUESTS: 'contact-request/contact-requests',
  /**
   * Contact requests assigned to the logged-in admin ("My Contact Requests").
   * Self-scoped to the caller's `users.id`; ADMIN-only (SUPER_ADMIN → 403).
   * Supports page/limit/search/startDate/endDate/sortOrder query params.
   */
  MY_ASSIGNED_CONTACT_REQUESTS: 'contact-request/contact-requests/my-tasks',
  /**
   * Full detail of a single contact request assigned to the logged-in admin
   * ("View my assigned task", RR-1096). Self-scoped: returns the task only when
   * it is assigned to the caller, otherwise 404 (a different admin's task and a
   * non-existent one are indistinguishable). ADMIN-only. Returns the enriched
   * status-history timeline alongside the standard detail fields.
   */
  VIEW_MY_ASSIGNED_TASK: (id: string) =>
    `contact-request/contact-requests/my-tasks/${id}`,
  PRESIGNED_URLS_BATCH: 'loopay-media-management/media/presigned-urls/batch',
  ASSIGN_CONTACT_REQUEST: (id: string) =>
    `contact-request/contact-requests/${id}/assign`,
  /**
   * Reassigns an already-`assigned` contact request to a different admin.
   * Body: `{ assignee_id, notify }` (notify defaults to false). Returns the
   * updated assignment plus `notification_sent`. SUPER_ADMIN | ADMIN.
   */
  REASSIGN_CONTACT_REQUEST: (id: string) =>
    `contact-request/contact-requests/${id}/reassign`,
  /**
   * Admins eligible to be assigned to a given contact request. Returns a paged
   * `{ data, pagination }` payload; supports page/limit/search query params
   * (search matches admin name OR user_id). SUPER_ADMIN | ADMIN.
   */
  ELIGIBLE_ASSIGNEES: (id: string) =>
    `contact-request/contact-requests/${id}/eligible-assignees`,
} as const;

export default contactRequestEndpoints;
